// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-templates-home-page-js": () => import("/Users/Jhondge/Documents/Dev/gitlab-projects/fotor-workspace/fotor-website-team/marketing-site/src/templates/home-page.js" /* webpackChunkName: "component---src-templates-home-page-js" */),
  "component---src-templates-feature-page-js": () => import("/Users/Jhondge/Documents/Dev/gitlab-projects/fotor-workspace/fotor-website-team/marketing-site/src/templates/feature-page.js" /* webpackChunkName: "component---src-templates-feature-page-js" */)
}

